import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

const i18nInstance = registerI18nResources({
  namespace: '@mc/banner',
  resources: { 'en-US': enUS },
})

export default i18nInstance
